import 'normalize.css';
import 'babel-polyfill';

import React from 'react';

import { Provider } from 'react-redux';
import { Route, Router, Redirect } from 'react-router';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import { history, store } from './store/configureStore';

import 'assets/images/favicon.ico';
import 'assets/sass/app.scss';

import api from './services';
import * as actionTypes from 'constants/ActionTypes';

// helpers
import Layout from './components/Layouts/Layout';

// login
import LoginPage from './components/Pages/Login';

// annotations
import LettersPage from './components/Letters/List/Page';
import TrainPage from './components/Letters/Single/Train/Page';
import AnnotatorVesselPage from './components/Letters/Single/Vessel/Page';
import AnnotatorVesselSizePage from './components/Letters/Single/Size/AnnotatorVesselSizePage';
import AnnotatorCargoPageNew from './components/Letters/SingleNew/Cargo/LetterCargo';
import VesselSales from './components/Letters/Single/Sales/Page';

// gazzeters
import GazetterPage from './components/Letters/Single/Gazetter/Page';

// regions
import PortsAltNamesPage from './components/Regions/PortsAltNames/Page';
import PortsPage from './components/Regions/Ports/Page';
import PortPage from './components/Regions/Port/Page';
import PortAddPage from './components/Regions/PortAdd/Page';
import PortApprovePage from './components/Regions/PortApprove/Page';
import AreasAltNamesPage from './components/Regions/AreasAltNames/Page';
import MergingPage from './components/Regions/Merging/Page';
import DashboardPage from './components/Regions/Dashboard/Page';

// cargoes
import CargoEditorPage from './components/Cargoes/Assigners/CargoEditorPage';
import CargoRealNamesPagePaginated from './components/Cargoes/RealNames/RealNamesPage';
import CargoDuplicatesPage from './components/Cargoes/Duplicates/Page';
import CargoLDRatesPage from './components/Cargoes/LDRates/Page';
import CargoRequestsPage from './components/Cargoes/Requests/Page';

// vessels
import VesselsListPage from './components/Vessels/List/Page';
import VesselRequestsPage from './components/Vessels/Requests/Page';
import VesselSalesPage from './components/Vessels/Sales/VesselSales';
import VesselClaimsPage from './components/Vessels/Claims/Page';
import VesselSinglePage from './components/Vessels/Single/Page';

// statistics
import StatisticsUserPage from './components/Statistics/Users/Page';
import StatisticsEmailPage from './components/Statistics/Emails/Page';
import StatisticsMonitorPage from './components/Statistics/Monitor/Page';
import StatisticsSt from './components/Statistics/St/Page';
import StatisticsComposition from './components/Statistics/Composition/Page';

// users list
import UserBanListPage from './components/Users/BanList/Page';
import UserDetails from './components/Users/Details';
import BlackAndWhiteListsPage from './components/Users/BlackAndWhiteLists/Page';
import SuspiciousSessions from './components/Users/SuspiciousSessions/Page';

// gazetteers
import GazetterEditorPage from './components/Gazetteers/Page';

// packing list
import PackingListPage from './components/PackingList/Page';

// tokens
import TokensPage from './components/Tokens/CheckToken/Page';

// sender email list
import SenderEmailListPage from './components/Letters/Sender/Page';
import SenderEmailSinglePage from './components/Letters/Sender/Single';

// sender email list
import Domains from './components/Domains/Page';

// Subscribers
import Subscribers from './components/Users/Subscribers/Page';

// backend notifications list
import BackendNotifications from './components/BackendNotifications/List';

// time charter table
import TimeCharter from './components/TimeCharter';
import Fuel from './components/Fuel';
import Disbursement from './components/Disbursement';
import IntegratorsListPage from 'components/Integrators/List/Page';
import IntegratorCompanies from 'components/Integrators/Companies/Page';
import IntegratorCompanyUser from 'components/Integrators/User/Page';

// ldrates
import reqLDRatesList from './components/Cargoes/RequestsLDRates/ReqLDRates';
import VesselUpdaterPage from './components/Statistics/vessel-updater/Page';

// pda
import Pda from './components/Prices/Pda/Pda';

import { LoginAsPage } from './components/LoginAsPage';

// timecharter
import LetterTc from './components/Letters/SingleNew/TC/LetterTc';
import TimeCharterRequests from './components/TimeCharter/Requests/Page';

// company real name
import CompanyRealName from './components/Companies/CompanyRealName/Page';

// Analytics
import AnalyticsDashboard from './components/Analytics/AnalyticsDashboard';

// FlagCompliance / detentions
import FlagCompliance from './components/FlagCompliance/FlagCompliance';
import Detentions from './components/Detentions/Detentions';

// vessels info composition
import VesselsCompositionMain from './components/Vessels/Composition/Main';
import VesselsComposition from './components/Vessels/Composition/Composition';

// tc index
import TcIndex from './components/TcIndex/TcIndex';

// mailers
import Mailers from './components/Analytics/mailers/Mailers';

// issue reports
import IssuesList from './components/Issues/List/List';
import Issue from './components/Issues/Issue/Issue';
import LoginAsPageCustom from './components/LoginAsPage/LoginAsPageCustom';

// rabbitmq queues stats
import { StatsRabbitmq } from 'components/Statistics/Queues/Page';

const Authentication = (nextState, replace, callback) => {
    api.getUser()
        .then((response) => {
            if (response.status === 200) {
                if (nextState.location.pathname === '/login') {
                    replace('/');
                }

                store.dispatch({
                    type: actionTypes.GET_USER.SUCCESS,
                    data: response.data,
                });
            }

            if (response.status !== 200) {
                if (nextState.location.pathname !== '/login') {
                    replace(`/login?backUrl=${encodeURIComponent(nextState.location.pathname)}`);
                }
            }

            callback();
        })
        .catch(() => {
            callback();
        });
};

const isAdmin = (nextState, replace, callback) => {
    api.getUser()
        .then((response) => {
            if (response.status === 200
                && response.data.role !== 'admin') {
                replace('/');
            }

            callback();
        })
        .catch(() => {
            callback();
        });
};

class App extends React.Component {
    render() {
        return (<Provider store={store}>
            <MuiThemeProvider>
                <Router history={history}>
                    <Route onEnter={Authentication}>
                        <Route path='/login' component={LoginPage} />
                        <Route component={Layout}>
                            <Route path='/' component={LettersPage} />

                            <Route path='tcIndex' component={TcIndex} />

                            <Route path='pda' component={Pda} />
                            <Route path='flagCompliance' component={FlagCompliance} />
                            <Route path='detentions' component={Detentions} />
                            <Route path='cargoes'>
                                <Route path='requests' component={CargoRequestsPage} />
                                <Route path='requests/ldRates' component={reqLDRatesList} />
                                <Route path='assigners' component={CargoEditorPage} />
                                <Route path='realnames' component={CargoRealNamesPagePaginated} />
                                <Route path='duplicates' component={CargoDuplicatesPage} />
                                <Route path='ldrates' component={CargoLDRatesPage} />
                            </Route>
                            <Route path='/tc' >
                                <Route path='requests' component={TimeCharterRequests} />
                            </Route>
                            <Route path="/integrators">
                                <Route
                                    path="list"
                                    component={IntegratorsListPage}
                                />
                                <Route
                                    path="companies/(:id)"
                                    component={IntegratorCompanies}
                                />
                                <Route
                                    path="(:integratorId)/user/(:id)"
                                    component={IntegratorCompanyUser}
                                />
                            </Route>

                            <Route path='regions'>
                                <Route path='altports' component={PortsAltNamesPage} />

                                <Route path='ports' component={PortsPage} />
                                <Route path='ports/add' component={PortAddPage} />
                                <Route exact path='ports/approve/:id' component={PortApprovePage} />
                                <Route path='ports/:id' component={PortPage} />

                                <Route path='altareas' component={AreasAltNamesPage} />
                                <Route path='merging' component={MergingPage} />
                                <Route path='dashboard' component={DashboardPage} />
                            </Route>

                            <Route path='vessels'>
                                <Route path='claims' component={VesselClaimsPage} />
                                <Route path='requests' component={VesselRequestsPage} />
                                <Route path='list' component={VesselsListPage} />
                                <Route path='add' component={VesselSinglePage} />
                                <Route path='sales' component={VesselSalesPage} />
                                <Route path='composition' component={VesselsCompositionMain} />
                                <Route path='composition/:id' component={VesselsComposition} />
                                <Route path=':id' component={VesselSinglePage} />
                            </Route>

                            <Route path='statistics' onEnter={isAdmin}>
                                <Route path='users' component={StatisticsUserPage} />
                                <Route path='emails' component={StatisticsEmailPage} />
                                <Route path='monitor' component={StatisticsMonitorPage} />
                                <Route path='st' component={StatisticsSt} />
                                <Route path='vessel-updater' component={VesselUpdaterPage} />
                                <Route path='composition' component={StatisticsComposition} />
                                <Route path='queues' component={StatsRabbitmq} />
                            </Route>

                            <Route path='sender' onEnter={isAdmin}>
                                <Route path='list' component={SenderEmailListPage} />
                                <Route path=':id' component={SenderEmailSinglePage} />
                            </Route>

                            <Route path='users' onEnter={isAdmin}>
                                <Route path='ban-list' component={UserBanListPage} />
                                <Route path='black-and-white-lists' component={BlackAndWhiteListsPage} />
                                <Route path='subscribers' component={Subscribers} />
                                <Route path='suspicious' component={SuspiciousSessions} />
                                <Route path=':id' component={UserDetails} />
                            </Route>

                            <Route
                                path='analytics'
                            >
                                <Route path='dashboard' component={AnalyticsDashboard} />
                                <Route path='mailers' component={Mailers} />
                            </Route>

                            <Route path='notifications'>
                                <Route path='list' component={BackendNotifications} />
                            </Route>

                            <Route path='gazetteer-editor' component={GazetterEditorPage} />

                            {
                                __DEV__ && <Route path='packing-list-recognition' onEnter={isAdmin} component={PackingListPage} />
                            }

                            <Route path='domains' component={Domains} />
                            <Route path='time-charter' component={TimeCharter} />
                            <Route path='fuel' component={Fuel} />
                            <Route path='disbursement' component={Disbursement} />

                            <Route path='tokens' onEnter={isAdmin}>
                                <Route path='check-token' component={TokensPage} />
                            </Route>

                            <Route path='/dev-only' component={LoginAsPage} />
                            <Route path='/varamar-only' component={LoginAsPageCustom} />

                            <Route path='/:id/train' component={TrainPage} />

                            <Route path='/:id' component={GazetterPage} />

                            <Route path=':id/annotator/vessel' component={AnnotatorVesselPage} />
                            <Route path=':id/annotator/cargo' component={AnnotatorCargoPageNew} />
                            
                            <Redirect from=':id/annotator/cargo/new' to=':id/annotator/cargo' />

                            <Route path=':id/size/vessel' component={AnnotatorVesselSizePage} />

                            <Route path=':id/annotator/tc' component={LetterTc} />
                            <Route path=':id/sales' component={VesselSales} />

                            <Route path='companies'>
                                <Route path='realnames' component={CompanyRealName} />
                            </Route>

                            <Route path='issues'>
                                <Route path='list' component={IssuesList} />
                                <Route path=':id' component={Issue} />
                            </Route>

                            <Route path='*' component={LettersPage} status={404} />
                        </Route>
                    </Route>
                </Router>
            </MuiThemeProvider>
                </Provider>);
    }
}

export default App;



// WEBPACK FOOTER //
// ./app/App.jsx